<template>
<div class="popup" v-cloak v-show="isShow">
    <div class="content" id="taskListSchdule">
        <div class="title">
            {{$t('language.popup.cloudTransferPopup.schedule')}}
            <div class="icon white-close dialog-close" @click.stop="closePopup()"></div>
        </div>
        <div class="task-schdule-body">
            <div class="schedule-content">
                <div class="schedule-content-item">
                    <div class="schedule-content-name">{{$t('language.common.frequency')}}</div>
                    <div class="schedule-selects">
                        <el-select class="schedule-select" v-model="activeName">
                            <div v-for="type in schedulesTypes" :key="type.id">
                                <el-option v-if="activeName!=type.id" :label="$t('language.popup.'+type.type)" :value="type.id"></el-option>
                            </div>
                        </el-select>
                    </div>
                </div>
                <div class="schedule-content-item">
                    <div class="schedule-content-name">{{$t('language.common.startTime')+":"}}</div>
                    <div class="schedule-items">
                        <tab1 ref="once" :disable="activeName == 1"></tab1>
                        <tab2 ref="daily" :disable="activeName == 2"></tab2>
                        <tab3 ref="weekly" :disable="activeName == 3"></tab3>
                        <tab4 ref="monthly" :disable="activeName == 4"></tab4>
                    </div>
                </div>
            </div>
            <div class="schedule-footer">
                <button class="schedule-save" @click.stop="save()">{{$t('language.common.save')}}</button>
                <button class="schedule-save white-button" style="margin-right:10px;" @click.stop="closePopup()">{{$t('language.common.cancel')}}</button>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import tab1 from "@/components/common/tabs/tabs_transfer_schedule/tab_once";
import tab2 from "@/components/common/tabs/tabs_transfer_schedule/tab_daily";
import tab3 from "@/components/common/tabs/tabs_transfer_schedule/tab_weekly";
import tab4 from "@/components/common/tabs/tabs_transfer_schedule/tab_monthly";
import commonUtils from "@/js/workspace/common_util.js";
export default {
    components: {
        tab1,
        tab2,
        tab3,
        tab4,
    },
    data: function () {
        return {
            activeName: null,
            isShow: false,
            schedulesTypes: [{id:1,type:'once'},{id:2,type:'daily'},{id:3,type:'weekly'},{id:4,type:'monthly'}],
            item: '',
            flag: true,
            itemIndex: -1,
        }
    },
    methods: {
        //初始化数据
        initDate(schedules) {
            this.$refs.once.initDate(this.activeName==1?schedules:null);
            this.$refs.daily.initDate(this.activeName==2?schedules:null);
            this.$refs.weekly.initDate(this.activeName==3?schedules:null);
            this.$refs.monthly.initDate(this.activeName==4?schedules:null);
        },
        //开启弹窗
        openPopup(itemValue,index) {
            this.isShow = true;
            this.activeName = 2;
            if(itemValue){
                let item = Object.assign({}, itemValue);
                this.item = item;
                
                //初始化数据 传入item时，复现时间，否则为当前时间
                if(item.schedules&&item.schedules.type) {
                    if (item.schedules && item.schedules.type != 'Now') {
                        if (item.schedules.type == 'Monthly' || item.schedules.type == '=Monthly') {
                            this.activeName = 4;
                        } else if (item.schedules.type == 'Weekly' || item.schedules.type == '=Weekly') {
                            this.activeName = 3;
                        } else if (item.schedules.type == 'Once' || item.schedules.type == '=Once'){
                            this.activeName = 1;
                        } else if (item.schedules.type == 'Daily' || item.schedules.type == '=Daily') {
                            this.activeName = 2;
                        }
                    }
                }

                //初始化数据
                this.initDate(item.schedules);
            }
        },
        //校验是否符合规定
        validatorTime(schedules){
            var timeValue = schedules.date + ' ' + schedules.times[0];
            var myDate = new Date();
            var now = myDate.valueOf();
            var time = new Date(timeValue).valueOf();
            if(now > time){
                return true;
            }else{
                return false;
            }
        },
        //保存并启动定时任务
        save() {
            var schedules;
            console.log(this.activeName)
            switch (this.activeName) {
                case 1:
                    schedules = this.$refs.once.getRunTime();
                    break;
                case 2:
                    schedules = this.$refs.daily.getRunTime();
                    break;
                case 3:
                    schedules = this.$refs.weekly.getRunTime();
                    break;
                case 4:
                    schedules = this.$refs.monthly.getRunTime();
                    break;
                default:
                    break;
            }

            console.log(schedules)
            if(!schedules) {
                this.$toast({
                    text: "未选择时间",
                    type: 'fail',
                    idValue: "allBox"
                });
                return false;
            }
            
            if( schedules.type == 'Once' && this.validatorTime(schedules)){
                this.$toast({
                    text: this.$t('language.teamTransfer.timePassed'),
                    type: 'fail',
                    idValue: "allBox"
                });
                return false;
            }

            //可以进行定时计划任务执行时，提示需要付费才能使用
            if (!commonUtils.getUser().vip) {
                var upgradeNewDialog = this.$parent.$refs.upgradeDialog;
                upgradeNewDialog.title = this.$t('language.paySystem.freePlanPopup.title_scheduled');
                upgradeNewDialog.curItem = 'scheduled';
                upgradeNewDialog.isShow = true;
                return false;
            }
            //     //3：定时任务限制提示
            //     this.$emit("upgrade",3);
            // }else {
            // }
            //设置保存定时任务，默认开启
            schedules.disabled = false;
            //设置服务器时间
            schedules.clientTime = commonUtils.getNowDateFormat();
            this.item.schedules = schedules;
            //执行修改计划
            this.$emit("update",this.item);

            this.closePopup();
        },
        closePopup() {
            this.isShow = false;
        },
    },
}
</script>

<style>
#taskListSchdule {
    width: 420px;
    /*no*/
    height: 442px;
    /*no*/
}

.task-schdule-body {
    width: 100%;
    height: calc(100% - 40px);
    /*no*/
    box-sizing: border-box;
    padding: 20px;
    /*no*/
}

.schedule-content {
    display: flex;
    flex-direction: column;
    font-family: PingFang SC;
    font-size: 14px;
    /*no*/
    font-weight: normal;
    line-height: 32px;
    /*no*/
    text-align: right;
    letter-spacing: 0em;
    color: #565D66;
}

.schedule-content-name {
    white-space: nowrap;
    line-height: 20px;/*no*/
    height: 25px;/*no*/
}

.schedule-selects {
    margin-bottom: 30px;
    /*no*/
}

.schedule-items {
    display: flex;
    align-items: center;
}

.schedule-content-item {
    flex-grow: 1;
    text-align: left;
}

.schedule-select {
    width: 100%;
    display: flex;
    flex-direction: column;
}

.schedule-content-item .el-input {
    width: 100%;
    height: 30px;
    /*no*/
}

.schedule-content-item .el-input input{
    width: 100%;
    margin: 0;
    height: 30px;
    /*no*/
    border-radius: 0;
    border: 1px solid #D3DCF0;/*no*/
}

.schedule-footer {
    position: absolute;
    bottom: 20px;
    /*no*/
    right: 20px;
    /*no*/
    width: auto;
    height: auto;
}

.el-scrollbar .el-scrollbar__wrap{
    margin-bottom: 0 !important;
    /*no*/
}

.el-input__icon {
    line-height: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/task_list_popups/task_list_schedule_popup.vue